import { Badge, Box, Group, Stack, Text } from '@mantine/core'
import { getCategoryLabel } from '@markku/utils'
import type { Service } from './utils'

/**
 * The RAG dot + task name + category badge — shared by the desktop table row
 * and the mobile card so the two layouts stay identical.
 */
export function ServiceLabel({
  service,
  color,
}: {
  service: Service
  color: string
}) {
  return (
    <Group gap="xs" wrap="nowrap" align="flex-start" style={{ minWidth: 0 }}>
      <Box
        w={10}
        h={10}
        mt={6}
        style={{
          borderRadius: '50%',
          background: `var(--mantine-color-${color}-6)`,
          flexShrink: 0,
        }}
      />
      <Stack gap={2} align="flex-start" style={{ minWidth: 0 }}>
        <Text size="sm" fw={600} c="brandBrown.7">
          {service.taskName}
        </Text>
        {service.category && (
          <Badge size="xs" variant="light" color="gray">
            {getCategoryLabel(service.category)}
          </Badge>
        )}
      </Stack>
    </Group>
  )
}
